import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../../services/api';
import { parseTableParams, formatDate } from '../../../utils/Utils';
import DataTable from '../../../components/ui/DataTable';
import LoadErrorBanner from '../../../components/ui/LoadErrorBanner';
import { readPage } from '../../../utils/apiResult';

// Task 35 — havuz aktivite geçmişi (TalentPoolActivity okuma ucu Task 35'te eklendi,
// bkz. backend GetPoolActivityAsync). Kapsam (İK tüm org / yönetici kendi ekibi) sunucuda
// uygulanır — burada yalnız görüntüleme.
//
// Task 35 fix turu (İncelemeci Important #2) — uç yalnız pageNumber/pageSize bind eder,
// filtre/sıralama YOK; bu yüzden tüm kolonlar filter:false/sort:false ve DataTable'ın
// filtre paneli `disableFilters` ile tamamen kapatıldı (aksi halde `dateFilterColumn`'ın
// ürettiği tarih aralığı filtresi/sıralaması sessizce no-op kalırdı — T31 sınıfı bulgu).
export default function PoolActivityTab({ poolId }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageIndex: 0, pageSize: 10 });
  const [fetching, setFetching] = useState(true);
  // TD-23 (kalan yüzeyler, Faz 2) — bkz. utils/apiResult.js: GET'lerde interceptor
  // reject ETMEZ, gerçek sinyal `res.data.status`. `.catch()` dalı ölü koddu ve
  // başarısız okuma "kayıt yok" gibi görünüyordu.
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (!poolId) return;
    setFetching(true);
    api.get(`/v1/talent-pool/pools/${poolId}/activity?${new URLSearchParams(queryParams)}`)
      .then((res) => {
        const { ok, items, pagination: page } = readPage(res);
        setLoadFailed(!ok);
        setData(items);
        setPagination(page);
      })
      .finally(() => setFetching(false));
  }, [poolId, queryParams]);

  const columns = useMemo(() => [
    { name: 'id', label: 'ID', options: { filter: false, sort: false, display: 'excluded' } },
    {
      name: 'employeeName',
      label: t('performance.talentpool.member'),
      options: { filter: false, sort: false },
    },
    {
      name: 'activityType',
      label: t('performance.talentpool.activityType'),
      options: {
        filter: false, sort: false,
        customBodyRender: (v) => t(`performance.talentpool.activity.${v}`, { defaultValue: v }),
      },
    },
    {
      name: 'detail',
      label: t('performance.talentpool.activityDetail'),
      options: { filter: false, sort: false },
    },
    {
      name: 'createDate',
      label: t('performance.common.createDate'),
      options: {
        filter: false, sort: false,
        customBodyRender: (v) => formatDate(v, lang),
      },
    },
  ], [t, lang]);

  const handleDataStateChange = (action, tableState) => {
    setQueryParams(parseTableParams(tableState, columns));
  };

  return (
    <>
      {loadFailed && <LoadErrorBanner />}
      <DataTable
      title={t('performance.talentpool.tabActivity')}
      fetching={fetching}
      columns={columns}
      data={data}
      totalRowCount={pagination.totalRowCount}
      pageIndex={pagination.pageIndex}
      pageSize={pagination.pageSize}
      disableFilters
      onTableChanged={handleDataStateChange}
      />
    </>
  );
}
